import React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import "./muiStepper.scss";

const MuiStepper = ({
  data,
  innerStep,
  formName,
  activeOuterStep,
  totalSteps,
}) => {
  return (
    <div className="muiStepper" style={{ width: "100%" }}>
      <Box className="stepperWrapper">
        <Box className="muiStepper">
          <div className="formName">
            <p>Order Form</p>
            <h4>{formName}</h4>
          </div>
          <div className="stepperSteps">
            <Stepper
              activeStep={activeOuterStep}
              orientation="vertical"
              className="willow-wood-stepper"
            >
              {data.map((label, index) => (
                <Step key={label.id}>
                  <StepLabel>{label.name}</StepLabel>
                  {activeOuterStep === index &&
                    label.innerSteps?.length > 0 && (
                      <div className="innerStepper">
                        <Stepper activeStep={innerStep} orientation="vertical">
                          {label.innerSteps.map((substep, subIndex) => (
                            <Step key={`innerStep-${substep.id}`}>
                              <StepLabel className="subStep">
                                {substep.name}
                              </StepLabel>
                            </Step>
                          ))}
                        </Stepper>
                      </div>
                    )}
                </Step>
              ))}
            </Stepper>

            <div className="mobleSteps">
              <p>
                Step {`0${activeOuterStep + 1}`}/{`0${totalSteps}`}
              </p>
            </div>
          </div>
        </Box>
        <Box sx={{ flex: "2", padding: 2 }} className="right-content">
          <>
            <div className="stepperContent">
              {data[activeOuterStep].formContent}
            </div>
          </>
        </Box>
      </Box>
    </div>
  );
};

export default MuiStepper;
